import React, { Component } from "react"
import { Button } from "antd";
import { get } from "../../lib/request";
import { makeAuthHeader } from "../../utils/auth";
import FileSaver from "file-saver";
export class FileDownloader extends Component{
  state = {
    downloading: false
  };

  _download = () => {
    this.setState({downloading: true});

    get(
      this.props.url,
      {},
      makeAuthHeader()
    ).then( response => {
        this.setState({ downloading: false});
        const blob = new Blob([response.data], {type: "text/plain;charset=utf-8"});
        FileSaver(blob, this.props.filename);
      }
    ).catch(function (error) {
      // console.log(error);
      //self.setState({ downloading: false });
      if (error.response) {
        // console.log('Error', error.response.status);
      } else {
        // console.log('Error', error.message);
      }
    });

  };

  render() {

    return (
      <div>
        <Button
          type="primary"
          loading={this.state.downloading}
          onClick={this._download}
        >
          {this.props.children}
        </Button>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/generic/FileDownloader.js